module.exports = __webpack_public_path__ + "img/531-11f4ba.png";